module.exports = __webpack_public_path__ + "static/media/accessories_stock80.4e1bf1f2.jpg";